<h2 mat-dialog-title>Comments for Case Number: {{ data.caseNumber }}</h2>
<mat-dialog-content>
  <table style="width: 100%; border-collapse: collapse; text-align: left;">
    <thead>
      <tr>
        <th style="border-bottom: 1px solid #ccc; padding: 8px;">Document Name</th>
        <th style="border-bottom: 1px solid #ccc; padding: 8px;">Comments</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let comment of data">
        <td style="border-bottom: 1px solid #ccc; padding: 8px;">
          {{ comment.documentTypeName }}
        </td>
        <td style="border-bottom: 1px solid #ccc; padding: 8px;">{{ comment.comments }}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
</mat-dialog-actions>
